import axios from "axios";
import { BACKEND_SERVER_URL } from "constants/api.constant";
import { PERSIST_STORE_NAME } from "constants/app.constant";
import deepParseJson from "utils/deepParseJson";

const api = axios.create({
  baseURL: `${BACKEND_SERVER_URL}`,
  withCredentials: true, // Required to send/receive cookies for SSO
});

// Add a request interceptor
api.interceptors.request.use(
  async function (config) {
    if (config.url === "/auth/login") {
      config.headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };
    } else {
      // Prioritize cookies (handled by browser due to withCredentials)
      // Fallback to localStorage token ONLY if cookie-based auth is not fully migrated
      const rawPersistData = await localStorage.getItem(PERSIST_STORE_NAME);
      const persistData = deepParseJson(rawPersistData);
      const token = persistData?.auth?.session?.token;

      config.headers = {
        "Content-Type": "application/json; charset=utf-8",
      };

      // Only attach Authorization header if token exists and we want to keep it as fallback
      if (token) {
        config.headers.Authorization = `${token}`;
      }
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// Add a response interceptor
api.interceptors.response.use(
  async function (response) {
    // For blob/arraybuffer responses, return the full response object
    // to preserve binary data and headers
    const isBlobResponse =
      response.config.responseType === "blob" ||
      response.config.responseType === "arraybuffer" ||
      response.headers?.["content-type"]?.includes("application/pdf") ||
      response.headers?.["content-type"]?.includes("application/octet-stream");

    if (isBlobResponse) {
      return response;
    }

    // For JSON responses, extract data
    const result = response.data;
    return result;
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  },
);

export default api;
